import { render, staticRenderFns } from "./BrTimeDistribution.vue?vue&type=template&id=0294bf34&scoped=true"
import script from "./BrTimeDistribution.vue?vue&type=script&lang=js"
export * from "./BrTimeDistribution.vue?vue&type=script&lang=js"
import style0 from "./BrTimeDistribution.vue?vue&type=style&index=0&id=0294bf34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0294bf34",
  null
  
)

export default component.exports